import { Link, useNavigate, useParams } from "react-router-dom";
import { selectPostList } from "../service/PostApiList";
import { useEffect, useState } from "react";
import Progress from "./Progress";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardActionArea from "@mui/material/CardActionArea";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import {
  Box,
  Breadcrumbs,
  Button,
  CardMedia,
  Divider,
  Grid,
} from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

const API_BASE = process.env.REACT_APP_APIURL;

const PostList = () => {
  const [arrPostData, setArrPostData] = useState([]);
  const [prevCategories, setPrevCategories] = useState(null);
  const [progress, setProgress] = useState(true);
  const params = useParams().id;
  const postID = Number(params);
  const admin = sessionStorage.getItem("admin");
  const navigate = useNavigate();
  const isAdmin = !(
    typeof admin == "undefined" ||
    admin == null ||
    admin == ""
  );
  const [thumbFailed, setThumbFailed] = useState(() => new Set());
  const markThumbFailed = (id) =>
    setThumbFailed((prev) => new Set(prev).add(id));

  useEffect(() => {
    fn();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fn2();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postID, arrPostData]);

  const fn = () => {
    selectPostList().then((res) => {
      const sortedData = res.data.slice().sort((a, b) => a.id - b.id);
      setArrPostData(sortedData);
      setProgress(false);
    });
  };

  const fn2 = () => {
    let targetData;
    let prevPostID = postID;
    let count = 0;
    let prevCategoriesTemp = [];

    if (arrPostData.length > 0) {
      do {
        targetData = arrPostData.find((v) => v.id === prevPostID);
        if (!targetData) break;

        prevCategoriesTemp.splice(0, 0, [targetData.id, targetData.title]);
        prevPostID = targetData.parentnode;
        count = count + 1;

        if (targetData.id === 1) break;
      } while (targetData.parentnode !== 0 && count < 10);
    }

    setPrevCategories(
      prevCategoriesTemp.map((v, idx) =>
        postID === v[0] ? (
          <Typography key={idx}>{v[1]}</Typography>
        ) : (
          <Link to={"/posts/" + v[0]} key={idx}>
            {v[1]}
          </Link>
        )
      )
    );
  };

  const thumb = (id, w = 320) => {
    const base = `${API_BASE}/posts/${id}/thumbnail?w=${w}&fmt=webp`;
    return base; // regdate 없으면 v 생략
  };

  return (
    <>
      <Progress progress={progress} />
      <div id="content">
        <Box sx={{ p: 2, bgcolor: "rgba(178, 144, 121, 0.3)" }}>
          <Box className="_postToolMenu">
            <Breadcrumbs
              separator={<NavigateNextIcon fontSize="small" />}
              aria-label="breadcrumb"
            >
              {prevCategories}
            </Breadcrumbs>

            {!isAdmin ? (
              ""
            ) : (
              <Box sx={{ display: "flex", justifyContent: "right" }}>
                <Button
                  component={Link}
                  to="/post/edit"
                  state={{ id: null, parentnode: postID, isNew: true }}
                  variant="contained"
                >
                  <Typography variant="body2" sx={{ color: "white" }}>
                    게시글 / 카테고리 생성
                  </Typography>
                </Button>
              </Box>
            )}
          </Box>

          <Divider sx={{ mt: 2, mb: 2 }} />

          {arrPostData.filter(
            (v) => v.parentnode === postID && (isAdmin || v.ispublic)
          ).length === 0 ? (
            <Box>하위 카테고리/게시글이 존재하지 않습니다.</Box>
          ) : (
            <Grid container spacing={2}>
              {arrPostData
                .filter(
                  (v) => v.parentnode === postID && (isAdmin || v.ispublic)
                )
                .map((v, idx) => (
                  <Grid item key={idx} md={6} lg={3}>
                    <Card sx={{ bgcolor: "#f6f5ec" }}>
                      <CardActionArea
                        LinkComponent={Link}
                        to={
                          "/post" + (v.category === "P" ? "" : "s") + "/" + v.id
                        }
                      >
                        <CardHeader
                          action={
                            !isAdmin ? (
                              ""
                            ) : (
                              <IconButton
                                aria-label="settings"
                                onClick={(e) => {
                                  e.preventDefault();
                                  navigate("/post/edit", {
                                    state: {
                                      id: v.id,
                                      parentnode: v.parentnode,
                                      isNew: false,
                                    },
                                  });
                                }}
                              >
                                <SettingsOutlinedIcon />
                              </IconButton>
                            )
                          }
                          title={
                            <Typography variant="h5">{v.title}</Typography>
                          }
                          subheader={new Date(v.regdate).toLocaleDateString()}
                          titleTypographyProps={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        />
                        <Divider />

                        {v.category === "C" ? (
                          // 카테고리는 폴더 이미지 고정
                          <CardMedia
                            component="img"
                            image={
                              process.env.PUBLIC_URL + "/folder_pixabay_4.png"
                            }
                            alt={v.title + " 대표 사진"}
                            loading="lazy"
                            sx={{
                              objectFit: "contain",
                              height: "192px",
                            }}
                          />
                        ) : !thumbFailed.has(v.id) ? (
                          <CardMedia
                            component="img"
                            image={thumb(v.id, 320)}
                            alt={`${v.title} 대표 사진`}
                            loading="lazy"
                            onError={() => markThumbFailed(v.id)}
                            // 실패 가능성이 있는 쪽에만 srcSet 부여
                            srcSet={[
                              `${thumb(v.id, 240)} 240w`,
                              `${thumb(v.id, 320)} 320w`,
                              `${thumb(v.id, 480)} 480w`,
                            ].join(", ")}
                            sizes="(max-width: 600px) 240px, 320px"
                            sx={{ objectFit: "contain", height: "192px" }}
                          />
                        ) : (
                          // 실패로 표시된 카드는 아예 폴백만 렌더 (srcSet/onError 없음)
                          <CardMedia
                            component="img"
                            image={process.env.PUBLIC_URL + "/post_pixabay.png"}
                            alt={`${v.title} 대표 사진(기본 이미지)`}
                            loading="lazy"
                            sx={{ objectFit: "contain", height: "192px" }}
                          />
                        )}
                      </CardActionArea>
                    </Card>
                  </Grid>
                ))}
            </Grid>
          )}
        </Box>
      </div>
    </>
  );
};

export default PostList;
